<template>
  <div class="point-payment-page">
    <div v-if="!paymentData" class="text-center py-5">
      <p>読み込み中...</p>
    </div>
    <b-modal
      v-else
      v-model="showModal"
      title="ポイントで購入"
      size="md"
      @show="onModalShow"
      @hidden="onModalHidden"
      hide-footer
      no-close-on-backdrop
    >
      <div class="point-payment-body">
        <p class="mb-3 font-weight-bold">{{ paymentData.content_title }}</p>
        <div class="d-flex justify-content-between mb-2">
          <span>必要ポイント</span>
          <span>{{ paymentData.required_points }} pt</span>
        </div>
        <div class="d-flex justify-content-between mb-3">
          <span>所持ポイント</span>
          <span>{{ paymentData.user_points }} pt</span>
        </div>
        <p v-if="paymentData.user_points < paymentData.required_points" class="text-danger small mb-2">
          ポイントが不足しています。
        </p>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="mr-2" @click="cancel">キャンセル</b-button>
          <b-button
            variant="primary"
            :disabled="paymentData.user_points < paymentData.required_points || loading"
            @click="executePayment"
          >
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            ポイントで購入する
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Constants } from "@/utils/constants.js";
import { Api } from "@/utils/http-common.js";
import { Urls } from "@/utils/urls.js";

export default {
  name: "PointPayment",
  data() {
    return {
      showModal: true,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["pointPaymentUrlData"]),
    paymentData() {
      return this.$store.state.pointPaymentUrlData;
    },
    shopId() {
      return this.$route.params.shopId || localStorage.getItem(Constants.SHOP_ID);
    },
  },
  watch: {
    paymentData: {
      immediate: true,
      handler(val) {
        if (!val && this.$route.name && (this.$route.name === "PointPayment" || this.$route.name === "PointPayment domain")) {
          this.redirectToLibrary();
        }
      },
    },
  },
  mounted() {
    if (!this.paymentData) {
      this.redirectToLibrary();
    }
  },
  methods: {
    redirectToLibrary() {
      this.$router.replace({
        name: this.$route.params.shopId ? "library" : "library domain",
        params: this.$route.params.shopId ? { shopId: this.$route.params.shopId } : {},
      });
    },
    onModalShow() {},
    onModalHidden() {
      this.$store.commit("set", ["pointPaymentUrlData", null]);
      this.redirectToLibrary();
    },
    cancel() {
      this.showModal = false;
    },
    async executePayment() {
      if (!this.paymentData || !this.paymentData.token || !this.shopId) return;
      if (this.paymentData.user_points < this.paymentData.required_points) return;
      this.loading = true;
      try {
        const res = await Api.userRequestServer.post(`/${Urls.URL}/execute-point-payment`, {
          token: this.paymentData.token,
          shop_id: parseInt(this.shopId, 10),
        });
        const data = res && res.data ? res.data : res;
        this.loading = false;
        if (data && data.success) {
          this.$toasted.success("購入が完了しました。");
          this.$store.commit("set", ["pointPaymentUrlData", null]);
          this.showModal = false;
          this.$router.replace({
            name: this.$route.params.shopId ? "library" : "library domain",
            params: this.$route.params.shopId ? { shopId: this.$route.params.shopId } : {},
          });
        } else {
          this.$toasted.error((data && data.message) || "購入に失敗しました。");
        }
      } catch (err) {
        this.loading = false;
        const msg = err.response && err.response.data && err.response.data.message
          ? err.response.data.message
          : "購入に失敗しました。";
        this.$toasted.error(msg);
      }
    },
  },
};
</script>

<style scoped>
.point-payment-body {
  min-height: 120px;
}
</style>
